import React from "react";
import { Link } from "react-router-dom";
import NetworkingCarousel from "../Ext/NetworkingCarousel";


const institutionsData = [
  {
    img: "./images/gd-logo.PNG",
    heading: "GD Goenka School Hyderabad",
    link: "https://gdgoenkahyd.com/",
  },
  {
    img: "./images/aekaksh-school-logo.PNG",
    heading: "Aekaksh School LB Nagar",
    link: "https://www.aekakshschool.com/",
  },
  {
    img: "./images/soulsportza-logo.PNG",
    heading: "Soul Sportza LB Nagar",
    link: "https://soulsportza.com/",
  },
  {
    img: "./images/aekaksh-school-logo.PNG",
    heading: "Aekaksh School Moosrambagh",
    link: "https://aekaksh2.netlify.app",
  },
  {
    img: "./images/aekaksh-school-logo.PNG",
    heading: "Aekaksh School Karmanghat",
    link: "https://aekaksh2311.netlify.app",
  },
  
];

const Institutions = () => {
  return (

    <>
    
    {/* <h1 className="h1-title">Institutions</h1>
    
    <div className="institutions-container">
      {institutionsData.map((institution, index) => (
        <div className="institutions-box" key={index}>
          <img
            src={institution.img}
            alt={institution.heading}
            className="institutions-image"
          />
          <h2 className="institutions-heading">{institution.heading}</h2>
          <Link to={institution.link} className="common-button">
            Learn More
          </Link>
        </div>
      ))}
    </div> */}

<NetworkingCarousel />

    
    </>
  );
};

export default Institutions;
